import React, { useState } from 'react';
import styles from './BrandInfo.module.scss';
import Container from '../../../templates/Container';
import classnames from '../../../../hooks/classnames';

const infoContent_1 = [
  {
    id: 1,
    title: 'Виртуальная выставка местных брендов',
    description: '',
  },
  {
    id: 2,
    title: 'Обучающие программы',
    description: 'акселераторы, форумы, другие мероприятия для развития предпринимательских компетенций',
  },
  {
    id: 3,
    title: 'Информационная поддержка в СМИ, социальных сетях, на тематических порталах',
    description: '',
  },
  {
    id: 4,
    title: 'Маркетинговые услуги',
    description:
      'маркетинговая стратегия, программы развития, регистрация прав на результаты интеллектуальной деятельности, сертификаты соответствия',
  },
];

const infoContent_2 = [
  {
    id: 1,
    title: 'Выставочно-ярмарочные мероприятия и торговые площади',
    description: 'в том числе на зарубежных площадках',
  },
  {
    id: 2,
    title: 'Конкурсы для выявления лучших местных брендов',
    description: '',
  },
  {
    id: 3,
    title: 'Продюсирование',
    description:
      'организация бизнес-процессов, связанных с маркетингом, рекламой, PR, IT, контентом, документами и продажей услуг и продуктов',
  },
  {
    id: 4,
    title: 'Инфраструктурная поддержка',
    description: '',
  },
  {
    id: 5,
    title: 'Региональные меры финансовой поддержки',
    description: '',
  },
];

const BrandInfo = () => {
  // const [openDescription, setOpenDescription] = useState({});

  // const toggleDescription = (id) => {
  //   setOpenDescription((prevState) => ({
  //     ...prevState,
  //     [id]: !prevState[id],
  //   }));
  // };

  return (
    <section className={styles.section}>
      <Container>
        <h2 className={styles.title}>Что даёт бренду участие в&nbsp;программе?</h2>
        <div className={styles.wrapper}>
          <ul className={styles.list}>
            {infoContent_1.map((item) => (
              <li className={styles.item} key={item.id}>
                <h3 className={styles.itemTitle}>
                  {item.title}
                  {/* {item.description && (
                  <button
                    className={classnames([styles.button, [styles.open, openDescription[item.id]]])}
                    onClick={() => toggleDescription(item.id)}>
                    +
                  </button>
                )} */}
                </h3>

                {item.description !== '' ? (
                  <p
                    className={classnames([
                      styles.itemDescription,
                      styles.open,
                      // , [styles.open, openDescription[item.id]]
                    ])}>
                    {item.description}
                  </p>
                ) : null}
              </li>
            ))}
          </ul>
          <ul className={styles.list}>
            {infoContent_2.map((item) => (
              <li className={styles.item} key={item.id}>
                <h3 className={styles.itemTitle}>{item.title}</h3>

                {item.description !== '' ? (
                  <p className={classnames([styles.itemDescription, styles.open])}>{item.description}</p>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
        <a
          href="http://www.zakon.krskstate.ru/dat/bin/docs_attach/192703_938_r.pdf"
          className={styles.link}
          target="_blank"
          rel="noreferrer">
          Полный перечень возможностей <span>(раздел 5&nbsp;Программы)</span>
        </a>
      </Container>
    </section>
  );
};

export default BrandInfo;
